import React from "react";

export interface BadgeProps {
  status?: "green" | "yellow" | "red" | "blue";
  text: string;
  caption?: string;
}

const Badge: React.FC<BadgeProps> = ({ status = "yellow", text, caption }) => {
  const colors = {
    green: "bg-sage",
    yellow: "bg-cantelope",
    red: "bg-red-500",
    blue: "bg-blue-500",
  };

  return (
    <>
      <div className="inline-flex w-fit shrink-0 items-center gap-2.5 whitespace-nowrap rounded-full bg-white px-3 py-1 outline outline-1 outline-oat">
        {status && (
          <div
            className={`h-2 w-2 shrink-0 rounded-full ${colors[status]}`}
            aria-hidden="true"
          />
        )}
        <p className="whitespace-nowrap text-sm font-bold text-soil">{text}</p>
      </div>
      {caption && <p className="text-xs text-soil">{caption}</p>}
    </>
  );
};

export default Badge;
